import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';
import Icon from './Icon';
import { KY_CORP_NUMBER, KY_PHONE } from 'src/constants/ky';
import { useTerms } from 'src/TermsContext';

export default function Footer(): JSX.Element {
  const { setIsTermShow, setIsPrivacyPolicyShow } = useTerms();
  const { t, i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.languages[0]);
  const changeLanguage = useCallback((e, nextLanguage) => {
    e.preventDefault();
    i18n.changeLanguage(nextLanguage);
    setCurrentLanguage(nextLanguage);
  }, []);

  return (
    <div className="w-full pt-6 py-9 border-ice-blue border-t">
      <div className="container flex flex-row justify-between">
        <div className="flex items-center">
          <a
            href="#"
            className={['N_12_M', currentLanguage === 'ko' ? 'text-black underline' : 'text-brown-grey'].join(' ')}
            onClick={(e) => changeLanguage(e, 'ko')}
          >
            한국어
          </a>
          <span className="mx-3 oval-1" />
          <a
            href="#"
            className={['N_12_M', currentLanguage === 'en' ? 'text-black underline' : 'text-brown-grey'].join(' ')}
            onClick={(e) => changeLanguage(e, 'en')}
          >
            ENG
          </a>
        </div>
        <button
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo(0, 0);
            return;
          }}
          className="p-1"
        >
          <Icon name="top" size="20" className="" />
        </button>
      </div>
      <p className="container N_12_R mt-9 text-black">
        {t('footer/ky_title')}
        {/* <span className={'ml-4 ' + (process.env.NODE_ENV === 'development' ? '' : 'opacity-0')}>v.{process.env.REACT_APP_APP_VERSION}</span> */}
        <span className={'ml-4 ' + (/(localhost|ky-www-dev|www-dev\.k-araoke\.com)/gi.test(location.href) ? '' : 'opacity-0')}>
          v.{process.env.REACT_APP_APP_VERSION}
        </span>
      </p>
      <div className="container N_12_R text-brown-grey mt-1.5">
        <dl className="flex flex-row items-start">
          <dt>
            {t('footer/address_title')}
            <span className="mx-1">:</span>
            <span>{t('footer/address_content')}</span>
          </dt>
          <dd></dd>
        </dl>
        <div className="flex flex-row items-center mt-1">
          <dl className="flex flex-row items-start">
            <dt>
              {t('footer/ceo_title')}
              <span className="mx-1">:</span>
            </dt>
            <dd>{t('footer/ceo_content')}</dd>
          </dl>
          <span className="division inline-block bg-ice-blue mx-2" />
          <dl className="flex flex-row items-start">
            <dt>
              {t('footer/corp_number_title')}
              <span className="mx-1">:</span>
            </dt>
            <dd>{KY_CORP_NUMBER}</dd>
          </dl>
        </div>
        <dl className="flex flex-row items-start mt-1">
          <dt>
            {t('footer/customer_phone_title')}
            <span className="mx-1">:</span>
            <span>{KY_PHONE}</span>
            <br />
            {t('footer/customer_phone_content')}
          </dt>
          <dd></dd>
        </dl>
      </div>
      <div className="container mt-6 flex items-center">
        <a
          href="#"
          className="N_12_R text-greyish-brown"
          onClick={(e) => {
            e.preventDefault();
            setIsTermShow(true);
          }}
        >
          {t('footer/terms_title')}
        </a>
        <span className="division mx-2 bg-brown-grey rounded" />
        <a
          href="#"
          className="N_12_R text-greyish-brown"
          onClick={(e) => {
            e.preventDefault();
            setIsPrivacyPolicyShow(true);
          }}
        >
          {t('footer/privacy_policy_title')}
        </a>
      </div>
    </div>
  );
}
